export const categories = [
  {
    slug: 'latest-news',
    name: '最新资讯',
    description: '行业动态、趋势分析与前沿报道',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'product-releases',
    name: '产品发布',
    description: '新产品上线、版本更新与功能迭代',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'announcements',
    name: '平台公告',
    description: '官方通知、政策变更与服务调整',
    icon: 'ri-megaphone-line',
  },
  {
    slug: 'events',
    name: '活动信息',
    description: '线上线下活动、沙龙与峰会预告',
    icon: 'ri-calendar-event-line',
  },
];